angular.module("planCtrModalModule", ["printGroupsModule", "reportModule", "pickReportsModule", "reportDetailsModule", "replyReportModule", "plancenterTaskModule", "createInfoModule", "plancenterInfoModule", "addRemarkModule", "infotypeModule", "passReportsModule", "replyReportV2Module", "connectPassageModule"]).factory("planCtrModalService", function($modal) {
    return {

        addRemark: function(topic) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/addRemark/addRemark.html",
                windowClass: "common-modal",
                backdrop: false,
                resolve: {
                    topic: function() {
                        return topic;
                    }
                },
                size: 'full',
                controller: "addremarkCtrl"
            });
            return modalInstance;
        },
        // 新增报题
        createReport: function(topic) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/createReport/createReport.html",
                windowClass: "plancenter-create-report common-modal",
                backdrop: false,
                resolve: {
                    topic: function() {
                        return topic;
                    }
                },
                size: 'full',
                controller: "createReportCtrl"
            });
            return modalInstance;
        },
        // 编辑报题
        editReport: function(report, topicName) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/createReport/createReport.html",
                windowClass: "plancenter-create-report common-modal",
                backdrop: false,
                resolve: {
                    report: function() {
                        return report;
                    },
                    topicName: function() {
                        return topicName;
                    }
                },
                controller: "editReportCtrl"
            });
            return modalInstance;
        },
        selectBestReports: function(topic, reports) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/checkSelectConfirm/checkSelectConfirm_tpl.html",
                windowClass: "confirm-report-modal common-modal",
                backdrop: false,
                size: 'lg',
                resolve: {
                    topic: function() {
                        return topic;
                    },
                    reports: function() {
                        return reports;
                    }
                },
                controller: "confirmPickReportsCtrl"
            });
            return modalInstance;
        },
        reportDetails: function(report) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/reportTitleDetail/reportTitleDetail_tpl.html",
                windowClass: "detail-modal common-modal",
                backdrop: false,
                size: 'lg',
                resolve: {
                    report: function() {
                        return report;
                    }
                },
                controller: "reportDetailsCtrl"
            });
            return modalInstance;
        },
        replyReport: function(report, type) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/replyReport/replyReport.html",
                windowClass: "reply-modal common-modal",
                backdrop: false,
                size: 'lg',
                resolve: {
                    report: function() {
                        return report;
                    },
                    type: function() {
                        return type;
                    }
                },

                controller: "replyReportCtrl"
            });
            return modalInstance;
        },
        assignTask: function(task) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/task/taskAssign.html",
                windowClass: "task-modal common-modal",
                backdrop: false,
                resolve: {
                    task: function() {
                        return task;
                    }
                },
                controller: "taskAssignCtrl"
            });
            return modalInstance;
        },
        viewTask: function(task) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/task/viewTask.html",
                windowClass: "task-modal common-modal",
                backdrop: false,
                resolve: {
                    task: function() {
                        return task;
                    }
                },
                controller: "viewTaskCtrl"
            });
            return modalInstance;
        },
        createInfo: function(success) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/createInfo/createInfo.html",
                windowClass: 'common-modal info-modal',
                size: 'lg',
                backdrop: false,
                controller: "createInfoCtrl",
                resolve: {}
            });
            modalInstance.result.then(function(result) {
                success(result);
            });
        },
        //新建广播信息页
        createBroadcastInfo: function(success) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/largeScreenControl/broadcast/service/createBroadcastInfo/createBroadcastInfo.html",
                windowClass: 'common-modal info-modal',
                size: 'lg',
                backdrop: false,
                controller: "createBroadcastInfoCtrl",
                resolve: {}
            });
            modalInstance.result.then(function(result) {
                success(result);
            });
        },
        createInfoType: function() {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/createInfotype/createInfoType.html",
                windowClass: 'common-modal',
                backdrop: false,
                controller: "createInfotypeCtrl",
                resolve: {}
            });
            return modalInstance;
        },
        editInfoType: function(type) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/createInfotype/editInfoType.html",
                windowClass: 'common-modal',
                backdrop: false,
                controller: "editInfotypeCtrl",
                resolve: {
                    type: type
                }
            });
            return modalInstance;
        },
        /**
         * [passReport description] 审批通过
         * @param  {[type]} report [description]
         * @param  {[type]} group  [description]
         * @return {[type]}        [description]
         */
        passReport: function(report, groupid, groupname) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/passReport/passReport.html",
                windowClass: "passReport-modal",
                backdrop: true,
                size: 'lg',
                resolve: {
                    report: function() {
                        return report;
                    },
                    groupid: function() {
                        return groupid;
                    },
                    groupname: function() {
                        return groupname;
                    }
                },
                controller: "confirmPassReportsCtrl"
            });
            return modalInstance;

        },
        /**
         * [printGroups description] 打印报题、选题
         * @param  {[type]} reports   [description] 报题、选题
         * @param  {[type]} groupname [description] 所在分组名
         * @param  {[type]} title     [description] 类型（报题、选题）
         * @return {[type]}           [description]
         */
        printGroups: function(reports, groupname, title) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/printGroups/printGroups.html",
                windowClass: "printgroups-modal",
                backdrop: true,
                size: 'lg',
                resolve: {
                    reports: function() {
                        return reports;
                    },
                    groupname: function() {
                        return groupname;
                    },
                    title: function() {
                        return title;
                    }
                },
                controller: "printGroupsCtrl"
            });
            return modalInstance;

        },
        replyNewReport: function(report, replycontent) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/replyReportV2/replyReportV2.html",
                windowClass: "reply-modal common-modal",
                backdrop: true,
                size: 'lg',
                resolve: {
                    report: function() {
                        return report;
                    },
                    replycontent: function() {
                        return replycontent;
                    }
                },
                controller: "replyReportCtrlV2"
            });
            return modalInstance;

        },
        /**
         * [connectPassage description] 关联稿件
         * @param  {[type]} report [description] 报题id
         * @return {[type]}        [description]
         */
        connectPassage: function(report) {
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/modal/connectPassage/connectPassage.html",
                windowClass: "connectPassage-modal",
                backdrop: true,
                size: 'lg',
                resolve: {
                    report: function() {
                        return report;
                    }
                },
                controller: "connectPassageCtrl"
            });
            return modalInstance;

        }
    }
});